import { ContextMenuItem } from '@components/ContextMenu';
import {
  ANALYSIS_TYPE_NAMES,
  BROWSER_LIST_CONTEXT_MENU_NAMES,
  Modality,
} from './labels';
import { Study } from '@models/Study';
import { Series } from '@models/Series';
import { AnalysisType } from './analysisConfig';
import { StudyViewState } from './studyConfig';
import {
  canUseCtFfrServerFeature,
  canUseDataGeneratorServerFeature,
  ServerFeatureSnapshot,
} from './serverFeatureState';

export type BrowserListContextMenuType =
  keyof typeof BROWSER_LIST_CONTEXT_MENU_NAMES;

export type BrowserListSortType = 'userId' | 'id' | 'completed';
export type RecentStudiesDropdownState = 'empty' | 'return' | 'active';

export interface SeriesSelection {
  id: string;
  percent: string;
}

export interface StudyState {
  studies: Study[];
  series: Record<string, Series[]>;
  loading: boolean;
  error: string | null;
  selectedStudyId: string | null;
  recentStudies: Study[];
  studyViewState: StudyViewState;
  seriesSelections: SeriesSelection[];
}

export const getContextMenuItemsForRow = (
  rowId: string,
  isAdmin: boolean,
  closeMenu: () => void,
  onDelete: (rowId: string) => void,
  onExportData: (rowId: string) => void,
  onReCalculate: (rowId: string) => void,
  onReCalculateCTFFR: (rowId: string) => void,
  onReGenerateData: (rowId: string) => void,
  onSendToPacs: (rowId: string) => void,
  serverFeatureState?: ServerFeatureSnapshot,
): ContextMenuItem[] => [
  {
    label: BROWSER_LIST_CONTEXT_MENU_NAMES.delete,
    onClick: () => {
      onDelete(rowId);
      closeMenu();
    },
  },
  {
    label: BROWSER_LIST_CONTEXT_MENU_NAMES.export,
    onClick: () => {
      onExportData(rowId);
      closeMenu();
    },
  },
  isAdmin
    ? {
        label: BROWSER_LIST_CONTEXT_MENU_NAMES.recalc,
        onClick: () => {
          onReCalculate(rowId);
          closeMenu();
        },
      }
    : null,
  isAdmin && canUseCtFfrServerFeature(serverFeatureState)
    ? {
        label: BROWSER_LIST_CONTEXT_MENU_NAMES.ctffr,
        onClick: () => {
          onReCalculateCTFFR(rowId);
          closeMenu();
        },
      }
    : null,
  isAdmin && canUseDataGeneratorServerFeature(serverFeatureState)
    ? {
        label: BROWSER_LIST_CONTEXT_MENU_NAMES.generateData,
        onClick: () => {
          onReGenerateData(rowId);
          closeMenu();
        },
      }
    : null,
  // {
  //   label: BROWSER_LIST_CONTEXT_MENU_NAMES.sendToPacs,
  //   onClick: () => {
  //     onSendToPacs(rowId);
  //     closeMenu();
  //   },
  // },
].filter(Boolean) as ContextMenuItem[];

export function getAllowedAnalysisTypes(
  modality: Modality,
  allowedAnalysisIds: string[],
): AnalysisType[] {
  return Object.keys(ANALYSIS_TYPE_NAMES[modality]).filter((type) =>
    allowedAnalysisIds.includes(type),
  ) as AnalysisType[];
}
